import './css/app.scss'

import initHeader from './js/components/header'
import initHIWSwiper from './js/components/how-it-works'
import initTestimonialsSwiper from './js/components/testimonials'
import initFAQOverview from './js/components/faq-overview'
import initNewsSwiper from './js/components/news-overview'
import initClientsSwiper from './js/components/clients'
import initMediaBox from './js/components/mediabox'
import initDefinitionColumns from './js/components/definition-columns'
import initPartnerAccordions from './js/components/partners'
import DataLayer from './dataLayer'

const initScripts = {
  init: function () {
    initHeader()
    initHIWSwiper()
    initTestimonialsSwiper()
    initFAQOverview()
    initNewsSwiper()
    initClientsSwiper()
    initMediaBox()
    initDefinitionColumns()
    initPartnerAccordions()
  },
}

initScripts.init()

!(async function () {
  if ('complete' === document.readyState) {
    window.tracking = new DataLayer()
  } else {
    window.addEventListener('load', () => {
      window.tracking = new DataLayer()
    })
  }
})()
